<template>
  <div class="variante-body secondary">
    <DeleteIcon
      class="produtos-close-variacoes-icon"
      @action="removerOpcao(idx)"
    />
    <div class="produtos-variacoes-container03">
      <div class="produtos-variacoes-container04">
        <div class="produtos-variacoes-container041">
          <label class="produtos-variacoes-text01 input-labels"
            >Tipo da opção</label
          >
          <v-select
            height="48"
            v-model="option.tipo"
            :items="$produtos_gerenciar.tipo_variacoes"
            item-value="key"
            item-text="value"
            class="produtos-variacoes-textinput"
            solo
            attach
            label="Tipos"
            :error-messages="$produtos_gerenciar.cadastro.variacoes.error.tipo"
            @input="$produtos_gerenciar.cadastro.variacoes.error.tipo = []"
          >
          </v-select>
        </div>
      </div>
    </div>
    <div class="values-label">
      <label class="produtos-variacoes-text012 input-labels">
        {{ optionTypeLabel }}
      </label>
    </div>
    <div
      class="produtos-variacoes-container03"
      v-for="(ipt, index) in option.valor"
      :key="index"
    >
      <div class="produtos-variacoes-container04">
        <div class="produtos-variacoes-container042" v-if="optionTypeDate">
          <OpcaoData
            :descricaoOpcao="ipt.descricao"
            @inputValue="ipt.descricao = $event"
            @remove="removerValor(index)"
          />
        </div>
        <div class="produtos-variacoes-container042" v-else-if="optionTypeHour">
          <v-text-field
            v-model="ipt.descricao"
            type="tel"
            class="produtos-add-edit-textinput"
            v-mask="'##:##'"
            placeholder="hh:mm"
            hide-details
            solo
            prepend-inner-icon="mdi-clock"
          >
            <template bottom slot="append-outer">
              <v-btn icon @click="removerValor(index)">
                <v-icon color="grey darken-2" small> mdi-trash-can </v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <div class="produtos-variacoes-container042" v-else>
          <v-text-field
            v-model="ipt.descricao"
            solo
            class="produtos-add-edit-textinput"
            hide-details
            placeholder="Adicionar outro valor"
            type="text"
          >
            <v-tooltip bottom slot="append">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="grey"
                  dark
                  small
                  @click="configItem(ipt)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Configurações</span>
            </v-tooltip>
            <template bottom slot="append-outer">
              <v-btn icon @click="removerValor(index)">
                <v-icon color="grey darken-2" small> mdi-trash-can </v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
      </div>
    </div>
    <div class="produtos-variacoes-container034">
      <div class="produtos-variacoes-container0423">
        <v-btn
          height="48"
          class="produtos-gerenciar-navlink1 button button-bg"
          v-if="!pronto"
          @click="criarVariaveis"
        >
          <span class="produtos-variacoes-text043">Pronto</span>
        </v-btn>
        <v-btn
          height="48"
          class="produtos-gerenciar-navlink1 button button-bg"
          @click="adicionarValor"
        >
          <span class="produtos-variacoes-text043">Adicionar outro valor</span>
        </v-btn>
      </div>
    </div>
    <OptionConfigDialog
      :dialogOpcao="dialogOpcao"
      :opcaoItem="opcaoItem"
      :opcaoIndex="opcaoIndex"
      :defaultOpcaoItem="defaultOpcaoItem"
      :idx="idx"
      :optionValor="option.valor"
      @close="closeConfigItem"
      @changeVariations="criarVariaveis"
    />
  </div>
</template>
<script>
import Vue from "vue";
import OpcaoData from "@/components/produtos/gerenciar/variants/opcao-data.vue";
import OptionConfigDialog from "@/components/produtos/gerenciar/variants/OptionConfigDialog.vue";
import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import { v4 } from "uuid";

export default {
  name: "VariantOption",
  components: {
    OpcaoData,
    OptionConfigDialog,
    DeleteIcon,
  },
  props: ["option", "idx"],
  data() {
    return {
      pronto: false,
      dialogOpcao: false,
      opcaoIndex: -1,
      opcaoItem: {
        descricao: "",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
      },
      defaultOpcaoItem: {
        descricao: "",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
      },
    };
  },
  computed: {
    optionType() {
      return this.option.tipo;
    },
    optionTypeLabel() {
      if (this.optionType == "DATA") {
        return "Defina as datas do evento";
      } else if (this.optionType == "HORA") {
        return "Defina os horários do evento";
      } else {
        return "Defina os tipos de ingresso";
      }
    },
    optionTypeHour() {
      return this.optionType == "HORA";
    },
    optionTypeDate() {
      return this.optionType == "DATA";
    },
  },
  methods: {
    /**
     * @description Método que remove opção de variações
     */
    removerOpcao(index) {
      this.$produtos_gerenciar.cadastro.variacoes.opcoes.splice(index, 1);
    },
    /**
     * @description Método que adiciona valor em opção de variação
     */
    adicionarValor() {
      this.pronto = false;
      this.option.valor.push({
        descricao: "",
        descricao_en_us: "",
        descricao_es_es: "",
        preco_default: "",
        qtd_default: "",
        prioridade: "",
        taxa: "",
        identificador: v4(),
      });
    },
    /**
     * @description Método que remove valor em opção de variação
     */
    removerValor(index) {
      this.$produtos_gerenciar.removeOpcao = true;

      const optionsValues = [...this.option.valor];
      const currentVariations =
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos;

      currentVariations.forEach((variacao, indexVar) => {
        if (variacao.nidvariacao) {
          variacao.nidvariacao.forEach(value => {
            if (optionsValues[index].idvariacao) {
              if (optionsValues[index].idvariacao == "") {
                if (value == optionsValues[index].identificador) {
                  this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.splice(
                    indexVar,
                    1
                  );
                  optionsValues.splice(index, 1)[0].idvariacao;
                  return;
                }
              } else if (value == optionsValues[index].idvariacao) {
                this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.splice(
                  indexVar,
                  1
                );
              }
            }
          });
        }
      });

      optionsValues.splice(index, 1)[0].idvariacao;

      const object = {
        tipo: "",
        pronto: this.pronto,
        valor: optionsValues,
      };

      object.tipo = this.option.tipo;

      Vue.set(
        this.$produtos_gerenciar.cadastro.variacoes.opcoes,
        this.idx,
        object
      );

      // this.pronto = true;
    },
    /**
     * @description Método que salva as opções criadas
     */
    criarVariaveis() {
      if (this.option.tipo == "") {
        this.$config.alert(
          "Selecione o tipo da opção antes!",
          this.$config.dados.errorColor
        );
        this.$produtos_gerenciar.cadastro.variacoes.error.tipo =
          "Selecione o tipo da opção antes!";
        return;
      }
      this.$produtos_gerenciar.removeOpcao = true;

      // let currentVariations = this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos
      const object = {
        tipo: "",
        pronto: this.pronto,
        valor: [],
      };

      object.tipo = this.option.tipo;

      this.option.valor.forEach(item => {
        object.valor.push({
          descricao: item.descricao,
          descricao_en_us: item.descricao_en_us,
          descricao_es_es: item.descricao_es_es,
          identificador: item.identificador || v4(),
          idvariacao: item.idvariacao || "",
          preco_default: item.preco_default || "",
          qtd_default: item.qtd_default || "",
          prioridade: item.prioridade || "",
          taxa: item.taxa || "",
        });
      });

      Vue.set(
        this.$produtos_gerenciar.cadastro.variacoes.opcoes,
        this.idx,
        object
      );

      // this.pronto = true;
    },
    /**
     * @description Método que abre modal de edição de variação
     */
    configItem(item) {
      this.opcaoIndex = this.option.valor.indexOf(item);
      this.opcaoItem = Object.assign({}, item);
      this.dialogOpcao = true;
    },
    /**
     * @description Método que fecha modal de edição
     */
    closeConfigItem() {
      this.dialogOpcao = false;
      this.$nextTick(() => {
        this.opcaoItem = Object.assign({}, this.defaultOpcaoItem);
        this.opcaoIndex = -1;
      });
    },
  },
  mounted() {
    if (!this.$axios.getLocal("tipos-variacoes")) {
      this.$produtos_gerenciar.getTiposVariacoes();
    }

    this.$produtos_gerenciar.tipo_variacoes =
      this.$axios.getLocal("tipos-variacoes").data;
  },
};
</script>
<style scoped>
.variante-body {
  width: auto;
  background-color: #c9c9c9;
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 10px;
}

.produtos-close-variacoes-icon {
  width: 30px;
  height: 30px;
  fill: #666 !important;
  transition: all 0.2s ease;
  position: absolute;
  right: 40px;
}

.produtos-close-variacoes-icon:hover {
  cursor: pointer !important;
  fill: #fff !important;
}

.produtos-variacoes-text01 {
  align-self: flex-start;
}

.produtos-variacoes-text012 {
  align-self: flex-end;
}

.produtos-variacoes-container03 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  margin-bottom: 0.625rem;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
}

.values-label {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2.5rem 10px 0px 10px;
  flex-direction: row;
}

.produtos-variacoes-container034 {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: row;
}

.produtos-variacoes-container04 {
  flex: 0 0 auto;
  width: 100%;
  height: 51px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.produtos-variacoes-textinput {
  width: 100%;
  height: 51px;
  border-radius: 10px;
}

.produtos-variacoes-container041 {
  flex: 0 0 auto;
  width: 50%;
  height: 100px;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
}

.produtos-variacoes-container042 {
  flex: 0 0 auto;
  width: 52.7%;
  height: 100px;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: row;
}

.produtos-variacoes-container0423 {
  flex: 0 0 auto;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: row;
  padding-top: 5px;
}

.produtos-gerenciar-navlink1 {
  color: var(--dl-color-gray-white);
  height: 51px;
  display: flex;
  border-width: 0px;
  margin-right: 10px;
  border-radius: 10px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}
</style>
